import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCore from '@app/core/store/core.reducer';

export const selectCoreState = createFeatureSelector<fromCore.State>(
    fromCore.coreFeatureKey
  );

export const selectLocationsState = createSelector(
    selectCoreState,
    (state: fromCore.State) => state.locations
  );
  
  export const selectMeState = createSelector(
    selectCoreState,
    (state) => state.me
  );

  export const selectIsNavOpen = createSelector(
    selectCoreState,
    (state) => state.isSideNavOpen
  );

  export const selectIsNavCollapsed = createSelector(
    selectCoreState,
    (state) => state.isSideNavCollapsed
  );

  export const selectTitle = createSelector(
    selectCoreState,
    (state) => state.title
  );

  export const showErrorMessage = createSelector(
    selectCoreState,
    (state) => state.error_message
  );